<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Email Placeholder</label>
      <input 
        v-model="localSettings.placeholder"
        type="text"
        class="form-input"
        placeholder="Enter your email"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Button Text</label>
      <input 
        v-model="localSettings.button_text"
        type="text"
        class="form-input"
        placeholder="Subscribe"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Action URL</label>
      <input 
        v-model="localSettings.action_url"
        type="url"
        class="form-input"
        placeholder="/newsletter/subscribe"
        @input="emitUpdate"
      />
      <p class="form-help-text">Where the form will submit to</p>
    </div>

    <div class="form-group">
      <label class="form-label">Button Color</label>
      <div class="form-color-input">
        <input 
          v-model="localSettings.button_color"
          type="color"
          @input="emitUpdate"
        />
        <input 
          v-model="localSettings.button_color"
          type="text"
          class="form-input"
          placeholder="#007bff"
          @input="emitUpdate"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">CSS Class</label>
      <input 
        v-model="localSettings.class"
        type="text"
        class="form-input"
        placeholder="custom-class"
        @input="emitUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  settings: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localSettings = ref({ 
  placeholder: 'Enter your email',
  button_text: 'Subscribe',
  action_url: '/newsletter/subscribe',
  button_color: '#007bff',
  class: '',
  ...props.settings 
});

watch(() => props.settings, (newSettings) => {
  localSettings.value = { ...newSettings };
}, { deep: true });

function emitUpdate() {
  emit('update', localSettings.value);
}
</script>

<style scoped>
.form-help-text {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}
</style>

